<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Adicionar Visitante' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>

  <ion-grid class="gradient-container" style="margin-top: -49px;">
    <ion-row class="ion-justify-content-center">
      <ion-col size="auto">
        <img [src]="pessoa.foto | image:' '" class="image" />
      </ion-col>
    </ion-row>

    <ion-row class="ion-justify-content-center">
      <ion-col size="auto">
        <p class="nome-pessoa bold-2">
          {{pessoa.id ? pessoa.nome : ("Nenhum Visitante Selecionado" |
          translate)}}
        </p>
      </ion-col>
    </ion-row>

    <ion-row class="ion-justify-content-center" [hidden]="pessoa.id">
      <ion-col size="10">
        <div *ngIf="userProvider.hasConfig(120)">
          <ion-button class="btn-default" expand="block" (click)="selecionarPessoa();">
            {{'Selecionar Visitante' | translate}}
          </ion-button>
        </div>
      </ion-col>
    </ion-row>

    <ion-row class="ion-justify-content-center" [hidden]="pessoa.id">
      <ion-col size="auto">
        <div *ngIf="userProvider.hasConfig(119)">
          <p class="criar" (click)="criarVisitante();">
            {{'Criar Visitante +' | translate}}
          </p>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>